import { Record as ImmutableRecord } from "immutable";

export type Nullable<T> = T | null | undefined;
export type AnyObject = Record<string, any>;
export type AbleProp = "default" | "yes" | "no";

export type IdType = number | string;
export type ExtendedRecord<T extends AnyObject, T2> = ImmutableRecord<T & T2>;

export type AssociationType = "Org" | "Job";
export const ORG: AssociationType = "Org";
export const JOB: AssociationType = "Job";

export type UrlType = "org" | "job";
export const ORG_URL: UrlType = "org";
export const JOB_URL: UrlType = "job";

export type FileWithPreview = File & {
  preview: {
    url: string;
  };
};

export type NumberKeysOf<T> = {
  [K in keyof T]: T[K] extends number ? K : never;
}[keyof T];

export type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T;
